export const getPaginateNotificationList = (
  notifications,
  status,
  currentPage,
  itemsPerPage
) => {
  let filterNotifications = [];

  let newNotifications = [];

  if (status === 'All message') {
    newNotifications = notifications;
  } else if (status === 'Read message') {
    newNotifications = notifications.filter(
      notification => notification.isRead === true
    );
  } else {
    newNotifications = notifications.filter(
      notification => notification.isRead === false
    );
  }

  newNotifications.forEach((e, index) => {
    if (
      index >= itemsPerPage * (currentPage - 1) &&
      index <= itemsPerPage * (currentPage - 1) + itemsPerPage - 1
    ) {
      filterNotifications.push(e);
    }
  });

  let newList = {
    page: currentPage,
    notifications: filterNotifications.length > 0 ? filterNotifications : null,
    size: newNotifications.length,
    totalPages: newNotifications.length / itemsPerPage
  };

  return newList;
};
